const en = {
  home: {
    title: 'Select a quiz'
  },
  navigation: {
    back: 'Back',
    start_message: 'Touch the screen to start'
  },
  quizGroup: {
    title: 'The RATP Group',
    description: 'Quiz about the RATP Group'
  },
  quizTransport: {
    title: 'Transport in Île-de-France',
    description: 'Quiz about transport in Île-de-France'
  },
  quizSolutionVille: {
    title: 'RATP Solutions Ville',
    description: 'Quiz about RATP Solutions Ville'
  },
  quizInnovation: {
    title: 'Innovation Vivatech 2025',
    description: 'Quiz about Innovation Vivatech 2025'
  },
  quizRatpDev: {
    title: 'RATP Dev',
    description: 'Quiz about RATP Dev'
  },
  quizGroupUMOP: {
    title: 'RATP Group Quiz\nUMOP 2026',
    description: 'RATP Group Quiz UMOP 2026'
  },
  quiz: {
    title: 'Quiz',
    question: 'Question',
    answer: 'Answer',
    next: 'Next',
    end: 'End',
    correct_answer: 'Correct answer',
    incorrect_answer: 'Incorrect answer',
    question_number: 'Question {{question}} of {{total}}',
    score_zero: 'Score: {{count}} point',
    score_one: 'Score: {{count}} point',
    score_other: 'Score: {{count}} points',
    end_page: {
      title: 'Quiz completed',
      score: 'Score: {{count}} points',
      comment: 'Thank you for participating!',
      home_btn: 'Back to home'
    },
    quit_confirmation: {
      title: 'Are you sure you want to quit the quiz?',
      message: 'All your progress will be lost.',
      cancel: 'Cancel',
      confirm: 'Quit'
    },

    quizGroup1: {
      title: 'Does RATP Group operate exclusively in Paris?',
      good_answer_comment:
        'Correct! RATP Group has operations in France and across the globe, and it runs urban and suburban multi-modal networks through over 100 contracts managed by its subsidiaries RATP Dev and RATP Cap Île-de-France.',
      bad_answer_comment:
        'Not quite. RATP Group has operations in France and across the globe, and it runs urban and suburban multi-modal networks through over 100 contracts managed by its subsidiaries RATP Dev and RATP Cap Île-de-France.',
      options: {
        '1': 'Yes',
        '2': 'No'
      }
    },
    quizGroup2: {
      title: 'In how many countries has RATP Group established a presence?',
      good_answer_comment:
        'Well done! RATP Group is established in 16 countries: South Africa, Saudi Arabia, Australia, Belgium, China, Egypt, the United States, France, Italy, Morocco, the Philippines, Hong Kong SAR, Qatar, Serbia, Singapore and Switzerland.',
      bad_answer_comment:
        'Incorrect. RATP Group is established in 16 countries: South Africa, Saudi Arabia, Australia, Belgium, China, Egypt, the United States, France, Italy, Morocco, the Philippines, Hong Kong SAR, Qatar, Serbia, Singapore and Switzerland.',
      options: {
        '1': '10',
        '2': '16',
        '3': '20',
        '4': '25'
      }
    },
    quizGroup3: {
      title:
        'RATP Group deploys optical fibre in the Île-de-France region through its subsidiary RATP Connect. How many kilometres of optical fibre are deployed?',
      good_answer_comment:
        'Yes! RATP Connect deployed 170,000 km of optical fibre across the Île-de-France region. The subsidiary is responsible for deploying and maintaining the optical fibre network, which contributes to the region’s connectivity and economic development.',
      bad_answer_comment:
        'No, RATP Connect deployed 170,000 km of optical fibre across the Île-de-France region. The subsidiary is responsible for deploying and maintaining the optical fibre network, which contributes to the region’s connectivity and economic development.',
      options: {
        '1': '1,500 km',
        '2': '15,000 km',
        '3': 'Over 150,000 km'
      }
    },
    quizGroup4: {
      title: 'How many transport modes does RATP Group operate on a daily basis?',
      good_answer_comment:
        'Correct! RATP Group operates 9 transport modes daily: metros, trams, urban and inter-city buses, regional trains, sightseeing buses, river/maritime shuttles, demand-responsive transport, ropeways, and autonomous vehicles.',
      bad_answer_comment:
        'Close! RATP Group operates 9 transport modes daily: metros, trams, urban and inter-city buses, regional trains, sightseeing buses, river/maritime shuttles, demand-responsive transport, ropeways, and autonomous vehicles.',
      options: {
        '1': '5',
        '2': '7',
        '3': '9',
        '4': '11'
      }
    },
    quizGroup5: {
      title: 'What is the approximate number of employees at RATP Group?',
      good_answer_comment:
        'Good job! RATP Group hires over 73,500 employees, a quarter of whom work outside France.',
      bad_answer_comment:
        'Not quite. RATP Group hires over 73,500 employees, a quarter of whom work outside France.',
      options: {
        '1': 'Below 50,000',
        '2': 'Between 50,000 and 70,000',
        '3': 'Between 70,000 and 80,000',
        '4': 'Over 80,000'
      }
    },
    quizGroup6: {
      title: 'Which transport mode does RATP Group not operate?',
      good_answer_comment:
        'Exactly! RATP Group operates 9 transport modes daily: metros, trams, urban and inter-city buses, regional trains, sightseeing buses, river/maritime shuttles, demand-responsive transport, ropeways, and autonomous vehicles.',
      bad_answer_comment:
        'No, RATP Group operates 9 transport modes daily: metros, trams, urban and inter-city buses, regional trains, sightseeing buses, river/maritime shuttles, demand-responsive transport, ropeways, and autonomous vehicles.',
      options: {
        '1': 'Metros',
        '2': 'Trams',
        '3': 'Airplanes',
        '4': 'Urban buses'
      }
    },
    quizGroup7: {
      title: 'How many professions are there across RATP Group?',
      good_answer_comment:
        "That's right! RATP Group employees belong to 270 different professions. Among the professions that are practised across the Group: metro drivers, maintenance technicians, transport systems engineers, security managers, communications officers, project managers.",
      bad_answer_comment:
        'Almost! RATP Group employees belong to 270 different professions. Among the professions that are practised across the Group: metro drivers, maintenance technicians, transport systems engineers, security managers, communications officers, project managers.',
      options: {
        '1': '30 professions',
        '2': '50 professions',
        '3': '100 professions',
        '4': 'Over 200 professions'
      }
    },
    quizGroup8: {
      title: 'Is RATP Group also in the real estate sector?',
      good_answer_comment:
        'Correct! RATP Group is active in the real estate sector, through several initiatives and subsidiaries, notably with RATP Habitat, which manages over 9,300 social and intermediate housing units across the Île-de-France region. RATP Real Estate is also involved in the Group’s real estate activity, and it oversees the redevelopment of mixed-use real estate projects that include converting industrial and office building sites into housing units, shops, and childcare centres.',
      bad_answer_comment:
        'Actually, yes. RATP Group is active in the real estate sector, through several initiatives and subsidiaries, notably with RATP Habitat, which manages over 9,300 social and intermediate housing units across the Île-de-France region. RATP Real Estate is also involved in the Group’s real estate activity, and it oversees the redevelopment of mixed-use real estate projects that include converting industrial and office building sites into housing units, shops, and childcare centres.',
      options: {
        '1': 'Yes',
        '2': 'No'
      }
    },
    quizGroup9: {
      title: 'Which services does the RATP Solutions Ville subsidiary provide?',
      good_answer_comment:
        'Exactly! As the subsidiary dedicated to urban services, RATP Solutions Ville brings together expertise from RATP Habitat, RATP Real Estate, RATP Connect and RATP Capital Innovation. This subsidiary caters to cities, regions, and companies in real estate, telecoms, energy, urban logistics and new forms of mobility.',
      bad_answer_comment:
        'Not quite! As the subsidiary dedicated to urban services, RATP Solutions Ville brings together expertise from RATP Habitat, RATP Real Estate, RATP Connect and RATP Capital Innovation. This subsidiary caters to cities, regions, and companies in real estate, telecoms, energy, urban logistics and new forms of mobility.',
      options: {
        '1': 'Real estate',
        '2': 'Telecoms',
        '3': 'Energy',
        '4': 'Urban logistics',
        '5': 'New forms of mobility'
      }
    },
    quizGroup10: {
      title: 'In which year was RATP Dev founded?',
      good_answer_comment: 'Correct! RATP Dev was founded in 2002.',
      bad_answer_comment: 'No, RATP Dev was founded in 2002.',
      options: {
        '1': '1970',
        '2': '1995',
        '3': '2002',
        '4': '2017'
      }
    },
    quizTransport1: {
      title: 'In which year did the ground-breaking ceremony take place for RER line A?',
      good_answer_comment: 'Correct! The construction of RER line A started in 1962.',
      bad_answer_comment: 'Incorrect. The ground-breaking ceremony for RER line A was in 1962.',
      options: {
        '1': '1961',
        '2': '1962',
        '3': '1964',
        '4': '1960'
      }
    },
    quizTransport2: {
      title: 'In which station was the first moving walkway installed in 1964?',
      good_answer_comment: 'Exactly! The first moving walkway was installed in Montparnasse.',
      bad_answer_comment: 'Almost! It was Montparnasse in 1964.',
      options: {
        '1': 'Châtelet',
        '2': 'Montparnasse',
        '3': 'Auber',
        '4': 'Saint-Germain-en-Laye'
      }
    },
    quizTransport3: {
      title: 'In which year were the first magnetic ticket gates installed?',
      good_answer_comment: 'Correct! Magnetic ticket gates appeared in 1968.',
      bad_answer_comment: 'Wrong, magnetic ticket gates were installed in 1968.',
      options: {
        '1': '1957',
        '2': '1968',
        '3': '1973',
        '4': '1981'
      }
    },
    quizTransport4: {
      title:
        'In which year was tram line T1 commissioned between Bobigny and Saint-Denis stations?',
      good_answer_comment: 'Well done! T1 was inaugurated in 1992.',
      bad_answer_comment: 'Incorrect. T1 started operating in 1992.',
      options: {
        '1': '1979',
        '2': '1985',
        '3': '1992',
        '4': '1996'
      }
    },
    quizTransport5: {
      title:
        'In which year was the new RATP Group visual identity unveiled, with its logo representing both a face and the River Seine flowing through Paris?',
      good_answer_comment: 'Yes! The current RATP logo dates back to 1992.',
      bad_answer_comment: 'The correct answer is 1992, for the new RATP logo.',
      options: {
        '1': '1982',
        '2': '1987',
        '3': '1992',
        '4': '1998'
      }
    },
    quizTransport6: {
      title: 'In which year was metro line 14 inaugurated?',
      good_answer_comment: 'Exactly! Line 14 was inaugurated in 1998.',
      bad_answer_comment: 'Wrong, line 14 opened in 1998.',
      options: {
        '1': '1995',
        '2': '1998',
        '3': '2000',
        '4': '2024'
      }
    },
    quizTransport7: {
      title: 'In which year was metro line 1 automated?',
      good_answer_comment: 'Well done! Line 1 was automated in 2011.',
      bad_answer_comment: 'Not quite. Line 1 was automated in 2011.',
      options: {
        '1': '2000',
        '2': '2007',
        '3': '2011',
        '4': '2016'
      }
    },
    quizTransport8: {
      title: 'When was RATP founded?',
      good_answer_comment: 'Correct! RATP was founded in 1949.',
      bad_answer_comment: 'Incorrect, RATP was founded in 1949.',
      options: {
        '1': '1905',
        '2': '1939',
        '3': '1949',
        '4': '1960'
      }
    },
    quizTransport9: {
      title: 'In which year was Paris metro line 1 inaugurated?',
      good_answer_comment: 'Correct! Line 1 was inaugurated in 1900.',
      bad_answer_comment: 'The correct answer is 1900.',
      options: {
        '1': '1895',
        '2': '1900',
        '3': '1905',
        '4': '1910'
      }
    },
    quizTransport10: {
      title: 'In which year were first-class carriages phased out from the Paris metro?',
      good_answer_comment: 'Exactly! First-class was phased out in 1985.',
      bad_answer_comment: 'Almost! It was in 1985 that first-class was removed.',
      options: {
        '1': '1991',
        '2': '1975',
        '3': '2000',
        '4': '1985'
      }
    },
    quizSolutionVille1: {
      title: 'What is the main mission of RATP Group subsidiary RATP Solutions Ville?',
      good_answer_comment:
        'Correct! RATP Solutions Ville helps tackle the challenges of urban ecological transition.',
      bad_answer_comment:
        'The correct answer was: providing urban services to cities for the ecological transition.',
      options: {
        '1': "In view of Île-de-France Mobilités' move to open to competition the operation of certain public transport networks, RATP Solutions Ville submits bids, and operates the transport networks to which it has been designated.",
        '2': 'Providing customised urban services to cities, local authorities, and companies, to facilitate cities’ ecological transition',
        '3': 'Operating urban and inter-city transport networks outside the long-standing RATP network in the Paris region',
        '4': 'Promoting social integration, by initiating and supporting public interest initiatives'
      }
    },
    quizSolutionVille2: {
      title:
        'RATP Solutions Ville provides integrated solutions across five key sectors: real estate, telecoms, urban logistics, new mobility, and...?',
      good_answer_comment: 'Correct! Energy completes the five key sectors.',
      bad_answer_comment:
        "The correct answer is energy, completing RATP Solutions Ville's key sectors.",
      options: {
        '1': 'Healthcare',
        '2': 'Sports',
        '3': 'Energy',
        '4': 'Education'
      }
    },
    quizSolutionVille3: {
      title:
        'Which structures are dedicated to real estate activities within RATP Solutions Ville?',
      good_answer_comment: 'Well spotted! They are RATP Habitat and RATP Real Estate.',
      bad_answer_comment: 'No, the real estate structures are RATP Habitat and RATP Real Estate.',
      options: {
        '1': 'RATP Cap Île-de-France and RATP Dev',
        '2': 'RATP Maintenance Service and RATP Sécurité Expertises',
        '3': 'RATP Capital Innovation and RATP Connect',
        '4': 'RATP Habitat and RATP Real Estate'
      }
    },
    quizSolutionVille4: {
      title: 'How many kilometers of optical fibre are deployed in Île-de-France by RATP Connect?',
      good_answer_comment: 'Correct! 170,000 km of fibre have been deployed by RATP Connect.',
      bad_answer_comment: '170,000 km of optical fibre have been deployed.',
      options: {
        '1': '170,000 km',
        '2': '27,000 km',
        '3': '1,200 km',
        '4': '640 km'
      }
    },
    quizSolutionVille5: {
      title: 'What is the main goal of RATP Capital Innovation?',
      good_answer_comment: 'Well done! The goal is to invest in sustainable and urban projects.',
      bad_answer_comment:
        'The correct answer is investing in sustainable mobility, urban real estate and logistics.',
      options: {
        '1': 'Investing exclusively in public transport sector companies',
        '2': 'Investing in projects that focus on sectors such as sustainable mobility, urban real estate, and last-mile logistics',
        '3': 'Funding exclusively information technology projects',
        '4': 'Investing in the petrol and gas industries to facilitate the energy transition'
      }
    },
    quizSolutionVille6: {
      title: 'What is the main mission of RATP Habitat?',
      good_answer_comment: 'Correct! RATP Habitat aims to house essential workers.',
      bad_answer_comment:
        'Not quite. Their main mission is to house essential workers in city centres.',
      options: {
        '1': 'Providing housing options exclusively to foreign students',
        '2': 'Building offices for local authorities',
        '3': 'Selling private housing units',
        '4': 'Accommodating essential workers from across the Île-de-France region at the city centre'
      }
    },
    quizSolutionVille7: {
      title: 'How does RATP Solutions Ville optimise unused bus depot space during the day?',
      good_answer_comment: 'Correct! These spaces are used for last-mile delivery.',
      bad_answer_comment: "No, it's to host last-mile delivery activities.",
      options: {
        '1': 'By converting them to parking spots for private individuals',
        '2': 'By accommodating last-mile delivery businesses',
        '3': 'By installing coworking areas there for start-ups',
        '4': 'By holding cultural events'
      }
    },
    quizSolutionVille8: {
      title: 'What are the environmental benefits measured from delivery microhubs in bus depots?',
      good_answer_comment: 'Correct! Microhubs enable significant pollutant reductions.',
      bad_answer_comment: "No, it's 80% GHG, 49% fine particles, and 80% NOx reductions.",
      options: {
        '1': '20% reduction in GHG emissions, and 10% reduction in NOx emissions',
        '2': '60% reduction in fine particulate emissions, and 30% reduction in GHG emissions',
        '3': '80% reduction in GHG emissions, 49% reduction in fine particulate emissions, and 80% reduction in NOx emissions',
        '4': '10% reduction in all categories of polluting emissions'
      }
    },
    quizInnovation1: {
      title: 'In how many countries is the RATP Group present?',
      good_answer_comment: 'Correct! The RATP Group is present in 16 countries via RATP Dev.',
      bad_answer_comment: 'No, the correct answer is 16 countries.',
      options: {
        '1': '1',
        '2': '7',
        '3': '16'
      }
    },
    quizInnovation2: {
      title: 'How many modes of transport does RATP operate?',
      good_answer_comment: 'Well done! RATP operates 9 different modes of transport.',
      bad_answer_comment: 'Wrong, RATP operates 9 modes of transport.',
      options: {
        '1': '3',
        '2': '5',
        '3': '9'
      }
    },
    quizInnovation3: {
      title: 'How many innovation projects are managed by RATP each year?',
      good_answer_comment: 'Good answer! About 300 innovation projects are managed each year.',
      bad_answer_comment: "No, it's 300 innovation projects each year.",
      options: {
        '1': '50',
        '2': '150',
        '3': '300'
      }
    },
    quizInnovation4: {
      title: 'To date, how many startups has RATP collaborated with?',
      good_answer_comment: 'Correct! More than 270 collaborations with startups.',
      bad_answer_comment: "That's not it. It's 270 startups that RATP has collaborated with.",
      options: {
        '1': '60',
        '2': '270',
        '3': '1,200'
      }
    },
    quizInnovation5: {
      title: 'What are the equipment worn by maintenance workers to reduce physical strain called?',
      good_answer_comment: 'Correct! They are exoskeletons.',
      bad_answer_comment: 'No, they are exoskeletons.',
      options: {
        '1': 'Impact vests',
        '2': 'Bionic equipment',
        '3': 'Exoskeletons'
      }
    },
    quizInnovation6: {
      title: 'In 2023, on which line did RATP test an autonomous bus?',
      good_answer_comment: 'Well done! It was indeed line 393.',
      bad_answer_comment: 'No, it was line 393.',
      options: {
        '1': 'Line 393 | Thiais – Carrefour de la Résistance ↔ Sucy-Bonneuil RER',
        '2': 'Line 39 | Issy-les-Moulineaux – Frères voisins ↔ Gare du Nord',
        '3': 'Line 4602 | Ulis 2 Shopping Center ↔ Massy-Palaiseau Station'
      }
    },
    quizInnovation7: {
      title: 'What is the main objective of the Bus 2025 program?',
      good_answer_comment: 'Correct! The program aims for a 100% clean fleet by 2025.',
      bad_answer_comment: 'Wrong, the objective is complete conversion to electric or biomethane.',
      options: {
        '1': 'Reduce the number of buses in circulation by 25%',
        '2': 'Replace only the oldest diesel buses',
        '3': 'Convert 100% of the bus fleet to electric or biomethane by 2025'
      }
    },
    quizInnovation8: {
      title: 'What are the 25,000 m3 of water recovered daily by RATP called?',
      good_answer_comment: 'Good answer! They are called exfiltration waters.',
      bad_answer_comment: 'No, they are called exfiltration waters.',
      options: {
        '1': 'Exfiltration waters',
        '2': 'Rainwater',
        '3': 'Grey water'
      }
    },
    quizInnovation9: {
      title: 'What percentage of waste is valorized by RATP?',
      good_answer_comment: 'Correct! 99.75% of waste is valorized.',
      bad_answer_comment: "Almost! It's 99% of valorized waste.",
      options: {
        '1': '32%',
        '2': '54%',
        '3': '99%'
      }
    },
    quizInnovation10: {
      title: 'Why was RER A equipped with "green" brake pads in 2024?',
      good_answer_comment: "Well done! It's for air quality in underground spaces.",
      bad_answer_comment: "No, it's to improve air quality.",
      options: {
        '1': 'To reduce brake maintenance costs',
        '2': 'To improve air quality in underground spaces',
        '3': 'To make braking completely silent'
      }
    },
    quizInnovation11: {
      title: 'In which major French city is the RATP Group NOT present?',
      good_answer_comment: 'Correct! The Group is not present in Strasbourg.',
      bad_answer_comment: 'No, RATP is not present in Strasbourg.',
      options: {
        '1': 'Brest',
        '2': 'Lyon',
        '3': 'Strasbourg',
        '4': 'Toulon'
      }
    },
    quizRatpDev1: {
      title: 'What is the main mission of RATP Dev?',
      good_answer_comment:
        'Correct! RATP Dev is the international subsidiary of the RATP Group, leader in high-capacity urban rail networks.',
      bad_answer_comment:
        'RATP Dev is the international subsidiary of the RATP Group, leader in high-capacity urban rail networks.',
      options: {
        '1': 'Manufacture trains',
        '2': 'Develop video games',
        '3': 'Operate and maintain public transport networks internationally',
        '4': 'Manage French railway infrastructure'
      }
    },
    quizRatpDev2: {
      title: 'In how many countries is RATP Dev present?',
      good_answer_comment: 'Correct! RATP Dev is present in 16 countries and 5 continents.',
      bad_answer_comment: 'RATP Dev is present in 16 countries and 5 continents.',
      options: {
        '1': 'Less than 5',
        '2': 'Around 10',
        '3': 'More than 15',
        '4': 'More than 25'
      }
    },
    quizRatpDev3: {
      title: 'How many employees does RATP Dev have worldwide?',
      good_answer_comment:
        'RATP Dev employs 25,000 people serving customers with passion, determination and humility.',
      bad_answer_comment: 'RATP Dev has 25,000 employees worldwide.',
      options: {
        '1': '2,000',
        '2': '5,000',
        '3': '10,000',
        '4': '25,000'
      }
    },
    quizRatpDev4: {
      title: 'Which of the following modes of transport are operated by RATP Dev?',
      good_answer_comment: 'Correct! RATP Dev operates many transport modes except air transport.',
      bad_answer_comment:
        'No, RATP Dev does not operate airplanes, but does operate metro, tram, and river shuttles.',
      options: {
        '1': 'Metro',
        '2': 'Tramway',
        '3': 'River shuttle',
        '4': 'Airplane'
      }
    },
    quizRatpDev5: {
      title: 'In 2024, which French city awarded RATP Dev the operation of its network?',
      good_answer_comment: 'Correct! The city of Lyon entrusted its TCL network to RATP Dev.',
      bad_answer_comment: 'That’s not correct. It’s Lyon that chose RATP Dev.',
      options: {
        '1': 'Toulouse',
        '2': 'Lyon',
        '3': 'Toulon',
        '4': 'Nice'
      }
    },
    quizRatpDev6: {
      title: 'Which automated metro projects does RATP Dev operate in the Middle East?',
      good_answer_comment: 'Correct! RATP Dev operates the automated metros of Riyadh and Doha.',
      bad_answer_comment: 'Incorrect. RATP Dev manages the Riyadh and Doha projects.',
      options: {
        '1': 'Dubai Metro',
        '2': 'Riyadh Metro',
        '3': 'Doha Metro',
        '4': 'Both B and C'
      }
    },
    quizRatpDev7: {
      title: 'What is the duration of the Sydney Metro – Western Sydney Airport contract?',
      good_answer_comment: 'Correct! The contract is for 15 years.',
      bad_answer_comment: 'Not quite. The correct answer is 15 years.',
      options: {
        '1': '5 years',
        '2': '10 years',
        '3': '15 years',
        '4': '20 years'
      }
    },
    quizRatpDev8: {
      title: 'What is unique about the Jurong Region Line project in Singapore?',
      good_answer_comment: 'Correct! It is a fully automated and elevated metro line.',
      bad_answer_comment:
        'Incorrect. It is a fully automated and elevated metro line, not a tram or freight line.',
      options: {
        '1': 'An underground line connecting the airport',
        '2': 'The city’s first tram line',
        '3': 'Fully automated and elevated',
        '4': 'Freight-only line'
      }
    },
    quizRatpDev9: {
      title: 'Which transport networks does RATP Dev operate in Riyadh?',
      good_answer_comment: 'Correct! RATP Dev operates both automated metro and BRT.',
      bad_answer_comment:
        'Not exactly. RATP Dev operates both automated metro and Bus Rapid Transit.',
      options: {
        '1': 'Automated metro',
        '2': 'Tramway',
        '3': 'Bus Rapid Transit',
        '4': 'Rail'
      }
    },
    quizRatpDev10: {
      title: 'What is the percentage of women at RATP Dev in South Africa?',
      good_answer_comment: 'Correct! 50% of the workforce are women – a perfect parity.',
      bad_answer_comment: 'Almost! It’s 50% of women in the workforce.',
      options: {
        '1': '35%',
        '2': '40%',
        '3': '50%',
        '4': '60%'
      }
    },
    quizRatpDevMobco1: {
      title: 'Quelle est la « vision » de RATP Dev ?',
      good_answer_comment:
        'Nous parlons de « choix naturel » parce que nous voulons que le transport public devienne une évidence pour les villes et les voyageurs. Un choix spontané, parce qu\'il répond à leurs attentes, leurs valeurs et leurs besoins.',
      bad_answer_comment:
        'Non, nous parlons de « choix naturel » parce que nous voulons que le transport public devienne une évidence pour les villes et les voyageurs. Un choix spontané, parce qu\'il répond à leurs attentes, leurs valeurs et leurs besoins.',
      options: {
        '1': 'Le choix naturel',
        '2': 'La mobilité pour tous',
        '3': 'Le choix durable',
        '4': 'Le meilleur de la mobilité'
      }
    },
    quizRatpDevMobco2: {
      title: 'Aujourd\'hui, dans combien de pays RATP Dev opère-t-elle ?',
      good_answer_comment: 'RATP Dev est présente dans 16 pays et 5 continents.',
      bad_answer_comment: 'Non, RATP Dev est présente dans 16 pays et 5 continents.',
      options: {
        '1': '9',
        '2': '16',
        '3': '12',
        '4': '18'
      }
    },
    quizRatpDevMobco3: {
      title: 'Quel est le nombre de voyages effectués chaque jour sur les réseaux de RATP Dev dans le monde ?',
      good_answer_comment:
        'À travers plus de 120 réseaux de transport, RATP Dev comptabilise au quotidien plus de 4,5 millions de voyages dans le monde.',
      bad_answer_comment:
        'Non, à travers plus de 120 réseaux de transport, RATP Dev comptabilise au quotidien plus de 4,5 millions de voyages dans le monde.',
      options: {
        '1': 'Plus de 2 millions',
        '2': 'Plus de 3 millions',
        '3': 'Plus de 4 millions',
        '4': 'Plus de 5 millions'
      }
    },
    quizRatpDevMobco4: {
      title: 'Cherchez l\'intrus ! Lequel de ces modes de transport N\'EST PAS exploité par RATP Dev ?',
      good_answer_comment:
        'RATP Dev exploite des réseaux de métro, du ferroviaire, des tramways, des bus, des navettes maritimes, des téléphériques... mais aucun dans l\'aérien !',
      bad_answer_comment:
        'Non, RATP Dev exploite des réseaux de métro, du ferroviaire, des tramways, des bus, des navettes maritimes, des téléphériques... mais aucun dans l\'aérien !',
      options: {
        '1': 'Métro',
        '2': 'Tramway',
        '3': 'Avion',
        '4': 'Navette maritime'
      }
    },
    quizRatpDevMobco5: {
      title: 'Début 2026, quelle région française a confié à RATP Dev l\'exploitation d\'une partie de son réseau ferroviaire ?',
      good_answer_comment:
        'La région Normandie a confié à RATP Dev l\'exploitation de l\'Étoile de Caen, ensemble stratégique de dix lignes ferroviaires autour de l\'agglomération caennaise, à compter de juillet 2027.',
      bad_answer_comment:
        'Non, la région Normandie a confié à RATP Dev l\'exploitation de l\'Étoile de Caen, ensemble stratégique de dix lignes ferroviaires autour de l\'agglomération caennaise, à compter de juillet 2027.',
      options: {
        '1': 'Bretagne',
        '2': 'Normandie',
        '3': 'Occitanie',
        '4': 'Corse'
      }
    },
    quizRatpDevMobco6: {
      title: 'Sur le réseau d\'Angers, quels modes de transport sont opérés par RATP Dev ?',
      good_answer_comment:
        'Avec plus de 43 millions de passagers par an, le réseau de la ville d\'Angers, opéré par RATP Dev, propose une offre de transport multimodale avec notamment 3 lignes de tramway, 31 lignes de bus, du transport à la demande ou encore une offre de vélo en libre-service.',
      bad_answer_comment:
        'Non, avec plus de 43 millions de passagers par an, le réseau de la ville d\'Angers, opéré par RATP Dev, propose une offre de transport multimodale avec notamment 3 lignes de tramway, 31 lignes de bus, du transport à la demande ou encore une offre de vélo en libre-service.',
      options: {
        '1': 'Tramway',
        '2': 'Bus',
        '3': 'Navette fluviale',
        '4': 'Vélo'
      }
    },
    quizRatpDevMobco7: {
      title: 'Quel mode de transport circulera sur la Suburban Rail Loop East à Melbourne, dont RATP Dev a remporté l\'exploitation fin 2025 ?',
      good_answer_comment:
        'RATP Dev apportera, durant toute la phase de construction, son expertise de futur exploitant de la ligne de métro 100 % automatique, puis en assurera l\'exploitation et la maintenance.',
      bad_answer_comment:
        'Non, RATP Dev apportera, durant toute la phase de construction, son expertise de futur exploitant de la ligne de métro 100 % automatique, puis en assurera l\'exploitation et la maintenance.',
      options: {
        '1': 'Une ligne ferroviaire',
        '2': 'Un réseau de BHNS',
        '3': 'Une ligne de métro automatique',
        '4': 'Un réseau de navettes TAD'
      }
    },
    quizRatpDevMobco8: {
      title: 'Combien de filiales compte la Business Unit France-Suisse de RATP Dev ?',
      good_answer_comment:
        'RATP Dev compte aujourd\'hui plus de 50 filiales sur la zone France-Suisse. Depuis plus de 20 ans, nous accompagnons ces collectivités pour proposer des solutions de mobilité ambitieuses.',
      bad_answer_comment:
        'Non, RATP Dev compte aujourd\'hui plus de 50 filiales sur la zone France-Suisse. Depuis plus de 20 ans, nous accompagnons ces collectivités pour proposer des solutions de mobilité ambitieuses.',
      options: {
        '1': 'Plus de 30',
        '2': 'Plus de 40',
        '3': 'Plus de 50',
        '4': 'Plus de 60'
      }
    },
    quizRatpDevMobco9: {
      title: 'Parmi ces thématiques, lesquelles font partie intégrante de nos engagements RSE ?',
      good_answer_comment:
        'Chez RATP Dev, nous faisons le choix d\'une RSE pragmatique et opérationnelle, imaginée collectivement, applicable partout. D\'une RSE pensée pour donner du sens à notre travail, renforcer la fierté d\'appartenance, et attirer les talents.',
      bad_answer_comment:
        'Non, chez RATP Dev, nous faisons le choix d\'une RSE pragmatique et opérationnelle, imaginée collectivement, applicable partout. D\'une RSE pensée pour donner du sens à notre travail, renforcer la fierté d\'appartenance, et attirer les talents.',
      options: {
        '1': 'Engagement social',
        '2': 'Engagement environnemental',
        '3': 'Engagement sociétal',
        '4': 'Engagement collectif'
      }
    },
    quizRatpDevMobco10: {
      title: 'Quel est l\'intrus ? Parmi ces affirmations, laquelle N\'EST PAS un enseignement de notre étude sur le futur du métro automatique ?',
      good_answer_comment:
        'L\'étude montre justement qu\'il ne faut pas se concentrer uniquement sur la technique, mais aussi sur l\'humain et l\'organisation. Pour découvrir tous les enseignements de cette étude, qui s\'appuie sur plus de 30 entretiens d\'experts menés à travers le monde, scannez le code !',
      good_answer_comment_image: 'quizRatpDevMobco-10-qr.webp',
      bad_answer_comment:
        'Non, l\'étude montre justement qu\'il ne faut pas se concentrer uniquement sur la technique, mais aussi sur l\'humain et l\'organisation. Pour découvrir tous les enseignements de cette étude, qui s\'appuie sur plus de 30 entretiens d\'experts menés à travers le monde, scannez le code !',
      bad_answer_comment_image: 'quizRatpDevMobco-10-qr.webp',
      options: {
        '1': 'Construire une gouvernance solide et adopter des modèles contractuels collaboratifs',
        '2': 'Faire de l\'automatisation une transformation technocentrée tout en gérant la complexité technique',
        '3': 'Offrir une expérience voyageurs en constante amélioration',
        '4': 'Positionner le métro automatique comme la colonne vertébrale, durable et résiliente, de la transformation urbaine'
      }
    },
    quizGroupUmop1: {
      title: 'In how many countries has RATP Group established a presence?',
      good_answer_comment:
        'Well done! RATP Group is established in 16 countries: South Africa, Saudi Arabia, Australia, Belgium, Canada, China Hong Kong SAR, Egypt, the United States, France, Italy, Morocco, the Philippines, Qatar, Serbia, Singapore and Switzerland.',
      bad_answer_comment:
        'Incorrect. RATP Group is established in 16 countries: South Africa, Saudi Arabia, Australia, Belgium, Canada, China Hong Kong SAR, Egypt, the United States, France, Italy, Morocco, the Philippines, Qatar, Serbia, Singapore and Switzerland.',
      options: {
        '1': '10',
        '2': '16',
        '3': '20',
        '4': '25'
      }
    },
    quizGroupUmop2: {
      title: 'How many transport modes does RATP Group operate on a daily basis?',
      good_answer_comment:
        'Correct! RATP Group operates 9 transport modes daily: metro, tram, urban and intercity bus, regional train, sightseeing, maritime shuttle, on-demand transport, cable and autonomous vehicle.',
      bad_answer_comment:
        'Close! RATP Group operates 9 transport modes daily: metro, tram, urban and intercity bus, regional train, sightseeing, maritime shuttle, on-demand transport, cable and autonomous vehicle.',
      options: {
        '1': '5',
        '2': '7',
        '3': '9',
        '4': '11'
      }
    },
    quizGroupUmop3: {
      title: 'How many different professions does RATP Group offer?',
      good_answer_comment:
        "That's right! RATP Group offers 270 different professions. For example: metro driver, maintenance technician, transport systems engineer, security manager, communications officer, project manager.",
      bad_answer_comment:
        'Almost! RATP Group offers 270 different professions. For example: metro driver, maintenance technician, transport systems engineer, security manager, communications officer, project manager.',
      options: {
        '1': '30',
        '2': '50',
        '3': '120',
        '4': 'over 250'
      }
    },
    quizGroupUmop4: {
      title:
        'How many RATP Group employees live in the Yvelines and Hauts-de-Seine areas?',
      good_answer_comment:
        'Correct! 7,133 RATP employees live there, including 2,547 in the Yvelines and 4,586 in Hauts-de-Seine (2024 figures).',
      bad_answer_comment:
        'Not quite. 7,133 RATP employees live there, including 2,547 in the Yvelines and 4,586 in Hauts-de-Seine (2024 figures).',
      options: {
        '1': '2,547',
        '2': '4,586',
        '3': '7,133',
        '4': '8,914'
      }
    },
    quizGroupUmop5: {
      title:
        'In your opinion, how many passengers use Île-de-France transport operated by RATP Group every day?',
      good_answer_comment:
        'Well done! More than 9 million passengers use the Île-de-France Mobilités network operated by RATP Group in Île-de-France.',
      bad_answer_comment:
        'No, more than 9 million passengers use the Île-de-France Mobilités network operated by RATP Group in Île-de-France.',
      options: {
        '1': 'about 500,000',
        '2': 'about 2 million',
        '3': 'about 9 million'
      }
    },
    quizGroupUmop6: {
      title:
        'Since 1 August 2023, which subsidiary operates many bus lines in Hauts-de-Seine and the Yvelines?',
      good_answer_comment:
        'Correct! RATP Cap Île-de-France is a private subsidiary of RATP Group created in 2021. It responds to calls for tender as part of the opening of public transport to competition led by Île-de-France Mobilités, and operates the networks it wins.',
      bad_answer_comment:
        'No, it is RATP Cap Île-de-France. A private subsidiary of RATP Group created in 2021, it responds to calls for tender as part of the opening of public transport to competition led by Île-de-France Mobilités.',
      options: {
        '1': 'RATP Expertises',
        '2': 'RATP Cap Île-de-France',
        '3': 'RATP Cap Arc Sud et Ouest'
      }
    },
    quizGroupUmop7: {
      title:
        'From 1 November, which bus line serving the city of Versailles is operated by RATP Cap Île-de-France?',
      good_answer_comment:
        'Good answer! Line 171 links Pont de Sèvres to the Palace of Versailles, via Sèvres, Chaville and Viroflay.',
      bad_answer_comment:
        'No, it is line 171 which links Pont de Sèvres to the Palace of Versailles, via Sèvres, Chaville and Viroflay.',
      options: {
        '1': 'line 171',
        '2': 'line 6201',
        '3': 'line 6217'
      }
    },
    quizGroupUmop8: {
      title: 'Which tram links the Hauts-de-Seine and Yvelines departments?',
      good_answer_comment:
        'Correct! Tram T6 links Châtillon-Montrouge to Viroflay and serves 12 stations across 4 communes in Hauts-de-Seine and 9 stations across 2 communes in the Yvelines.',
      good_answer_comment_image: 'quizGroupUMOP-8-reponse.webp',
      good_answer_comment_image_layout: 'wide',
      bad_answer_comment:
        'Not quite. Tram T6 links Châtillon-Montrouge to Viroflay and serves 12 stations across 4 communes in Hauts-de-Seine and 9 stations across 2 communes in the Yvelines.',
      bad_answer_comment_image: 'quizGroupUMOP-8-reponse.webp',
      bad_answer_comment_image_layout: 'wide',
      options: {
        '1': 'T2',
        '2': 'T6',
        '3': 'T13'
      }
    },
    quizGroupUmop9: {
      title:
        'How many stations does the RER B serve in Hauts-de-Seine and the Yvelines?',
      good_answer_comment:
        'Well done! 11 stations in total, including 2 on the central section, 6 on the St Rémy branch and 3 on the Robinson branch.',
      good_answer_comment_image: 'quizGroupUMOP-9-reponse.webp',
      good_answer_comment_image_layout: 'wide',
      bad_answer_comment:
        'No, there are 11 stations in total, including 2 on the central section, 6 on the St Rémy branch and 3 on the Robinson branch.',
      bad_answer_comment_image: 'quizGroupUMOP-9-reponse.webp',
      bad_answer_comment_image_layout: 'wide',
      options: {
        '1': '6',
        '2': '9',
        '3': '11'
      }
    },
    quizGroupUmop10: {
      title:
        'How many communes does the RER A serve in the Yvelines and Hauts-de-Seine?',
      good_answer_comment:
        'Correct! 13 communes (Chatou, Le Vésinet, St Germain-en-Laye, Conflans-Ste-Honorine, Houilles, Maisons-Laffitte, Poissy, Sartrouville, Achères, Rueil-Malmaison, Nanterre, Puteaux, Courbevoie) host stations.',
      bad_answer_comment:
        'Not quite. 13 communes (Chatou, Le Vésinet, St Germain-en-Laye, Conflans-Ste-Honorine, Houilles, Maisons-Laffitte, Poissy, Sartrouville, Achères, Rueil-Malmaison, Nanterre, Puteaux, Courbevoie) host stations.',
      options: {
        '1': '10',
        '2': '13',
        '3': '17'
      }
    },
    quizGroupUmop11: {
      title:
        'Which Grand Paris Express (GPE) lines will serve Hauts-de-Seine and the Yvelines?',
      good_answer_comment:
        'Correct! Lines 15 and 18. Line 15 (south and west) will link Bagneux station to Les Grésillons station (Gennevilliers). Line 18 will serve Versailles Chantiers, Satory, St Quentin Est and Antony pôle station.',
      bad_answer_comment:
        'No, it is lines 15 and 18. Line 15 (south and west) will link Bagneux station to Les Grésillons station (Gennevilliers). Line 18 will serve Versailles Chantiers, Satory, St Quentin Est and Antony pôle station.',
      options: {
        '1': 'Lines 15 and 16',
        '2': 'Lines 16 and 17',
        '3': 'Lines 15 and 18'
      }
    },
    quizGroupUmop12: {
      title: 'Do you know what is the most frequently forgotten item on public transport?',
      good_answer_comment: 'Well done! The most frequently forgotten item on public transport is an umbrella.',
      bad_answer_comment: 'No, the most frequently forgotten item on public transport is an umbrella.',
      options: {
        '1': 'an umbrella',
        '2': 'a bag',
        '3': 'a phone'
      }
    }
  }
} as const

export default en
